import styles from './UpcomingBirthdays.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import UpcomingDataCard from '../../components/UpcomingDataCard/UpcomingDataCard';
import { PiCakeBold } from 'react-icons/pi';
import { NavLink } from 'react-router';
// import Cake from '../../assets/images/Cake.png'; // Replace with correct path

export const UpcomingBirthdays = () => {
  const birthdayData = [
    { title: 'Steeve john', value: '3A', index: 1 },
    { title: 'Joseph', value: '3A', index: 2 },
    { title: 'Samad', value: '3A', index: 3 },
    { title: 'Samad', value: '3A', index: 3 },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<PiCakeBold />} heading="Upcoming Birthdays" />
        <NavLink className={styles.viewAll} to={'calender/birthdays'}>
          View All
        </NavLink>
      </div>

      <div className={styles.list}>
        {birthdayData.map((item, i) => {
          if (i < 3) {
            return (
              <UpcomingDataCard
                key={i}
                index={item.index}
                title={item.title}
                value={item.value}
                labelType="date"
              />
            );
          }
        })}
      </div>
    </div>
  );
};
